import React from 'react';
import {
  injectIntl,
  WrappedComponentProps,
  FormattedMessage
} from '@kyruus/intl';

import { RATINGS_AND_REVIEWS } from '../../lib/constants';
import messages from '../../lib/messages';
import {
  AverageRatingHeading,
  AverageRatingContainer,
  RatingsReviewsCount
} from './styles';
import StarRating from './star-rating';

const AverageRating = ({
  averageRating,
  ratingCount,
  reviewCount,
  intl
}: {
  averageRating: number;
  ratingCount: number;
  reviewCount: number;
} & WrappedComponentProps): React.ReactElement => {
  return (
    <AverageRatingContainer>
      <StarRating
        rating={averageRating}
        starSize={RATINGS_AND_REVIEWS.SUMMARY_STAR_SIZE_DESKTOP}
        widthAccuracyCorrection={
          RATINGS_AND_REVIEWS.SUMMARY_STARS_ACCURACY_CORRECTION_WIDTH
        }
      />
      <meta itemProp="worstRating" content="1" />
      <meta itemProp="bestRating" content="5" />
      <AverageRatingHeading
        itemProp="ratingValue"
        content={averageRating.toString()}
        tabIndex={0}
        aria-label={`${intl.formatMessage(messages.ariaStarRatingsAverage, {
          averageRating,
          rating: averageRating
        })}`}
      >
        {`${averageRating} ${intl.formatMessage(messages.ratingScale)}`}
      </AverageRatingHeading>
      <RatingsReviewsCount>
        <FormattedMessage
          {...messages.ratingReviewCount}
          values={{
            ratingCount,
            reviewCount,
            ratings: ratingCount,
            reviews: reviewCount
          }}
        />

        <span className="sr-only" aria-hidden={true}>
          <span itemProp="ratingCount">{ratingCount}</span>
          <span itemProp="reviewCount">{reviewCount}</span>
        </span>
      </RatingsReviewsCount>
    </AverageRatingContainer>
  );
};

export default injectIntl(AverageRating);
